function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aca35970-08da-4729-95d8-3f50493bb4d9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f98d4728-d919-446e-b081-f2d1a7fb912b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 365.5,
    cy: -56,
    r: 68,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bdc45ae6-f754-4466-83c6-316e56e58e23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-109.5-.31a1.47,1.47,0,0,0-1.56-1.5q-1.18,0-2.37,0c-.38,0-.55.17-.57.55V-.4c0,.41.19.58.6.59h1.87c0,.09,0,.14,0,.19,0,1.25,0,2.49,0,3.74a2.76,2.76,0,0,1-.21,1.07,16.4,16.4,0,0,1-1.22,2.16,2.46,2.46,0,0,1-4.15-.06l-.46-.69a4.63,4.63,0,0,1-.93-2.47c0-1.29,0-2.58,0-3.87,0,0,0,0,0-.06h1.88c.39,0,.56-.18.57-.56s0-.59,0-.88-.17-.56-.58-.56h-2.31a1.5,1.5,0,0,0-1.6,1.59c0,1.1,0,2.21,0,3.32a10.69,10.69,0,0,0,.1,1.26,10.59,10.59,0,0,0,2,4.6c.55.79,1.16,1.54,1.74,2.32a2.55,2.55,0,0,1,.63,1.5c0,1.05,0,2.1,0,3.15a4,4,0,0,1-2.58,3.57,5.92,5.92,0,0,1-2.25.26A4,4,0,0,1-125,15.63c0-1.09,0-2.18,0-3.27a.31.31,0,0,1,.24-.35,3.49,3.49,0,0,0,2.26-3.4,3.5,3.5,0,0,0-4.84-3.12A3.53,3.53,0,0,0-129,10.58a3.53,3.53,0,0,0,2,1.52c0,.86,0,1.72,0,2.58a14.07,14.07,0,0,0,.08,1.95,5.8,5.8,0,0,0,3.27,4.5,7.42,7.42,0,0,0,5.3.37,5.84,5.84,0,0,0,4.24-5c.1-.94,0-1.9.07-2.85,0-.65.1-1.3.17-2a.89.89,0,0,1,.39-.66c.46-.37.92-.74,1.35-1.14a7.67,7.67,0,0,0,2.51-5c.15-1.72.12-3.45.12-5.17m-16.38,11.22A1.84,1.84,0,0,1-127.68,9a1.83,1.83,0,0,1,1.86-1.75A1.83,1.83,0,0,1-124,9.13a1.83,1.83,0,0,1-1.83,1.78",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b0d6e344-3c1c-44dc-9503-91480e64b85d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.93,3H66.1A.94.94,0,0,0,67,2a.94.94,0,0,0-.92-1H62.94A.93.93,0,0,0,62,2a1,1,0,0,0,.93,1",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a116a78f-9cff-4b85-9ae9-d4c297af7160"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67,3.12a.91.91,0,0,0,.94.88,1,1,0,0,0,1-.84c0-.77,0-1.55,0-2.33A.91.91,0,0,0,68,0a.94.94,0,0,0-1,.88V3.12",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bfe92b28-b05a-42f8-a667-41c39f8753f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.88,13.06a5.65,5.65,0,0,0-1.81-3.2A.5.5,0,0,1,73,9.54c0-1.49,0-3,0-4.49,0-.62,0-1.25,0-1.87A2.22,2.22,0,0,0,71,1a10.61,10.61,0,0,0-1.26,0,.86.86,0,1,0,0,1.71c.32,0,.64,0,1,0a.5.5,0,0,1,.52.48c0,.55,0,1.11,0,1.67H56.68V3.37a.59.59,0,0,1,.64-.66h.82A.87.87,0,0,0,59,1.94.84.84,0,0,0,58.29,1a6,6,0,0,0-1.58.05A2.24,2.24,0,0,0,55,3.37v11.5A2.37,2.37,0,0,0,56.07,17a2.62,2.62,0,0,0,1.45.35H64.3a.36.36,0,0,1,.33.15,5.52,5.52,0,0,0,5,2.54,5.33,5.33,0,0,0,3.74-1.69,5.7,5.7,0,0,0,1.55-5.25M63.78,15.6H57.37c-.47,0-.68-.2-.68-.68,0-2.72,0-5.45,0-8.17a.69.69,0,0,1,0-.13H71.25V8.73A5.52,5.52,0,0,0,65.54,9.9a5.84,5.84,0,0,0-1.76,5.7m5.52,2.69a4.09,4.09,0,1,1,4-4.06,4.05,4.05,0,0,1-4,4.06",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e3aa7509-9383-4ce7-b54b-86044960d6a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.64,14a.57.57,0,0,1-.14-.42c0-.56,0-1.11,0-1.66s-.38-.93-.76-.9A.9.9,0,0,0,69,12V13c0,.34,0,.69,0,1a1.27,1.27,0,0,0,.28.86c.47.59.94,1.18,1.42,1.76a.66.66,0,0,0,1.08,0,1.14,1.14,0,0,0,0-1.4L70.64,14",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7fc348a-51b6-43ff-91e8-53a1643cb406"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-57.07,3h3.17A.94.94,0,0,0-53,2a.94.94,0,0,0-.92-1h-3.14A.93.93,0,0,0-58,2a1,1,0,0,0,.93,1",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f5a7e7e9-2a2f-4245-a4c1-aad908ba239a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-53,3.12a.91.91,0,0,0,.94.88A1,1,0,0,0-51,3.16c0-.77,0-1.55,0-2.33A.91.91,0,0,0-52,0a.94.94,0,0,0-1,.88V3.12",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e19db5d3-85fc-4c56-862d-b56210081f09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-45.12,13.06a5.65,5.65,0,0,0-1.81-3.2A.5.5,0,0,1-47,9.54c0-1.49,0-3,0-4.49,0-.62,0-1.25,0-1.87A2.22,2.22,0,0,0-49,1a10.61,10.61,0,0,0-1.26,0,.86.86,0,0,0-.87.83.86.86,0,0,0,.88.88c.32,0,.64,0,.95,0a.5.5,0,0,1,.52.48c0,.55,0,1.11,0,1.67H-63.32V3.37a.59.59,0,0,1,.64-.66h.82A.87.87,0,0,0-61,1.94.84.84,0,0,0-61.71,1a6,6,0,0,0-1.58.05A2.24,2.24,0,0,0-65,3.37v11.5A2.37,2.37,0,0,0-63.93,17a2.62,2.62,0,0,0,1.45.35h6.78a.36.36,0,0,1,.33.15,5.52,5.52,0,0,0,5,2.54,5.33,5.33,0,0,0,3.74-1.69,5.7,5.7,0,0,0,1.55-5.25m-11.1,2.54h-6.41c-.47,0-.68-.2-.68-.68,0-2.72,0-5.45,0-8.17a.69.69,0,0,1,0-.13h14.55V8.73A5.52,5.52,0,0,0-54.46,9.9a5.84,5.84,0,0,0-1.76,5.7m5.52,2.69a4.05,4.05,0,0,1-4-4.16,4.06,4.06,0,0,1,4-4,4.05,4.05,0,0,1,4,4.11,4,4,0,0,1-4,4.06",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad44f586-dc5a-4e96-af26-277210232a61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-49.36,14a.57.57,0,0,1-.14-.42c0-.56,0-1.11,0-1.66s-.38-.93-.76-.9A.9.9,0,0,0-51,12V13c0,.34,0,.69,0,1a1.27,1.27,0,0,0,.28.86c.47.59.94,1.18,1.42,1.76a.66.66,0,0,0,1.08,0,1.14,1.14,0,0,0,0-1.4L-49.36,14",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a6d28dbb-bace-4da0-b11f-3707a1dfda78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.28-1678.47a.82.82,0,0,0-.82.82v1a.49.49,0,0,1-.48.49H37.41a.82.82,0,0,0-.82.82.82.82,0,0,0,.82.82H40a2.12,2.12,0,0,0,2.12-2.13v-1a.82.82,0,0,0-.82-.82",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fbba2ff7-43d0-4e43-b769-c02a4e85258d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.76-1678.47a.83.83,0,0,0-.83.82v1a.48.48,0,0,1-.48.49H43.89a.82.82,0,0,0-.83.82.83.83,0,0,0,.83.82h2.56a2.13,2.13,0,0,0,2.13-2.13v-1a.82.82,0,0,0-.82-.82",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b4e6318d-44c5-4b77-9108-a9957c38d398"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.28-1673.73a.82.82,0,0,0-.82.82v1a.49.49,0,0,1-.48.49H37.41a.82.82,0,0,0-.82.82.82.82,0,0,0,.82.82H40A2.12,2.12,0,0,0,42.1-1672v-1a.82.82,0,0,0-.82-.82",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f6a4f059-ffc5-4caf-8b39-2e26af207232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.76-1673.73a.83.83,0,0,0-.83.82v1a.48.48,0,0,1-.48.49H43.89a.82.82,0,0,0-.83.82.83.83,0,0,0,.83.82h2.56a2.13,2.13,0,0,0,2.13-2.13v-1a.82.82,0,0,0-.82-.82",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac0b9906-e2c7-486f-bc57-79be3c38ebae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.22-1481.72a.83.83,0,0,0-.82.83v1a.49.49,0,0,1-.48.48h-2.57a.82.82,0,0,0-.82.82.82.82,0,0,0,.82.82h2.57a2.12,2.12,0,0,0,2.12-2.12v-1a.83.83,0,0,0-.82-.83",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f285245f-689b-4657-99c1-649a82ffec7e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16.74-1481.72a.83.83,0,0,0-.83.83v1a.48.48,0,0,1-.48.48h-2.56a.83.83,0,0,0-.83.82.82.82,0,0,0,.83.82H-18a2.12,2.12,0,0,0,2.13-2.12v-1a.83.83,0,0,0-.82-.83",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb239fea-9b57-4aa6-9ec9-526040cedd6f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.22-1477a.83.83,0,0,0-.82.83v1a.49.49,0,0,1-.48.48h-2.57a.82.82,0,0,0-.82.82.82.82,0,0,0,.82.82h2.57a2.12,2.12,0,0,0,2.12-2.12v-1a.83.83,0,0,0-.82-.83",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a5b1e6be-d5fb-46a4-8868-08e6dd481b43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16.74-1477a.83.83,0,0,0-.83.83v1a.48.48,0,0,1-.48.48h-2.56a.83.83,0,0,0-.83.82.82.82,0,0,0,.83.82H-18a2.12,2.12,0,0,0,2.13-2.12v-1a.83.83,0,0,0-.82-.83",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fde5d1d4-24f7-42ac-a01c-86710dfc293e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7,7.3a.82.82,0,0,0-.83.82v1a.47.47,0,0,1-.48.48H32.83a.83.83,0,1,0,0,1.65h2.56a2.13,2.13,0,0,0,2.13-2.13v-1a.82.82,0,0,0-.82-.82",
    style: {
      fill: "#516983",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a236e09a-fec4-4fe5-8cda-d3f6b58c4cf7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.17,7.3a.82.82,0,0,0-.82.82v1a.48.48,0,0,1-.48.48H39.3a.83.83,0,0,0,0,1.65h2.57A2.14,2.14,0,0,0,44,9.07v-1a.82.82,0,0,0-.83-.82",
    style: {
      fill: "#516983",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e1f46e9f-317d-4918-84f0-d37a54986df4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7,12a.82.82,0,0,0-.83.82v1a.47.47,0,0,1-.48.48H32.83a.83.83,0,1,0,0,1.65h2.56a2.13,2.13,0,0,0,2.13-2.13v-1A.82.82,0,0,0,36.7,12",
    style: {
      fill: "#516983",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a697d55b-3b91-4f47-bd38-d54ede5bd62c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.17,12a.82.82,0,0,0-.82.82v1a.48.48,0,0,1-.48.48H39.3a.83.83,0,0,0,0,1.65h2.57A2.14,2.14,0,0,0,44,13.81v-1a.82.82,0,0,0-.83-.82",
    style: {
      fill: "#516983",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac6369aa-a362-49a4-8bf2-dafd4baed624"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7,56.3a.82.82,0,0,0-.83.82v1a.47.47,0,0,1-.48.48H4.83a.83.83,0,1,0,0,1.65H7.39a2.13,2.13,0,0,0,2.13-2.13v-1a.82.82,0,0,0-.82-.82",
    style: {
      fill: "#516983",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f59e0390-ff4b-4fc1-aff7-f203e4f5f6aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.17,56.3a.82.82,0,0,0-.82.82v1a.48.48,0,0,1-.48.48H11.3a.83.83,0,0,0,0,1.65h2.57A2.14,2.14,0,0,0,16,58.07v-1a.82.82,0,0,0-.83-.82",
    style: {
      fill: "#516983",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aff9449a-6cde-46fe-87a5-48f701b8e269"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7,61a.82.82,0,0,0-.83.82v1a.47.47,0,0,1-.48.48H4.83a.83.83,0,1,0,0,1.65H7.39a2.13,2.13,0,0,0,2.13-2.13v-1A.82.82,0,0,0,8.7,61",
    style: {
      fill: "#516983",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b0c89aee-de45-4f0b-96b8-86d0647e9d8d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.17,61a.82.82,0,0,0-.82.82v1a.48.48,0,0,1-.48.48H11.3a.83.83,0,0,0,0,1.65h2.57A2.14,2.14,0,0,0,16,62.81v-1a.82.82,0,0,0-.83-.82",
    style: {
      fill: "#516983",
      clipRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.7,7.3a.82.82,0,0,0-.83.82v1a.47.47,0,0,1-.48.48H32.83a.83.83,0,1,0,0,1.65h2.56a2.13,2.13,0,0,0,2.13-2.13v-1a.82.82,0,0,0-.82-.82",
    style: {
      fill: "#516983",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#fde5d1d4-24f7-42ac-a01c-86710dfc293e)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -808.79,
    y: -653.22,
    width: 1528,
    height: 4751,
    style: {
      fill: "#516983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.17,7.3a.82.82,0,0,0-.82.82v1a.48.48,0,0,1-.48.48H39.3a.83.83,0,0,0,0,1.65h2.57A2.14,2.14,0,0,0,44,9.07v-1a.82.82,0,0,0-.83-.82",
    style: {
      fill: "#516983",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a236e09a-fec4-4fe5-8cda-d3f6b58c4cf7)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -808.79,
    y: -653.22,
    width: 1528,
    height: 4751,
    style: {
      fill: "#516983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.7,12a.82.82,0,0,0-.83.82v1a.47.47,0,0,1-.48.48H32.83a.83.83,0,1,0,0,1.65h2.56a2.13,2.13,0,0,0,2.13-2.13v-1A.82.82,0,0,0,36.7,12",
    style: {
      fill: "#516983",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#e1f46e9f-317d-4918-84f0-d37a54986df4)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -808.79,
    y: -653.22,
    width: 1528,
    height: 4751,
    style: {
      fill: "#516983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.17,12a.82.82,0,0,0-.82.82v1a.48.48,0,0,1-.48.48H39.3a.83.83,0,0,0,0,1.65h2.57A2.14,2.14,0,0,0,44,13.81v-1a.82.82,0,0,0-.83-.82",
    style: {
      fill: "#516983",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a697d55b-3b91-4f47-bd38-d54ede5bd62c)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -808.79,
    y: -653.22,
    width: 1528,
    height: 4751,
    style: {
      fill: "#516983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,56.3a.82.82,0,0,0-.83.82v1a.47.47,0,0,1-.48.48H4.83a.83.83,0,1,0,0,1.65H7.39a2.13,2.13,0,0,0,2.13-2.13v-1a.82.82,0,0,0-.82-.82",
    style: {
      fill: "#516983",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#ac6369aa-a362-49a4-8bf2-dafd4baed624)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -836.79,
    y: -604.22,
    width: 1528,
    height: 4751,
    style: {
      fill: "#516983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.17,56.3a.82.82,0,0,0-.82.82v1a.48.48,0,0,1-.48.48H11.3a.83.83,0,0,0,0,1.65h2.57A2.14,2.14,0,0,0,16,58.07v-1a.82.82,0,0,0-.83-.82",
    style: {
      fill: "#516983",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f59e0390-ff4b-4fc1-aff7-f203e4f5f6aa)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -836.79,
    y: -604.22,
    width: 1528,
    height: 4751,
    style: {
      fill: "#516983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,61a.82.82,0,0,0-.83.82v1a.47.47,0,0,1-.48.48H4.83a.83.83,0,1,0,0,1.65H7.39a2.13,2.13,0,0,0,2.13-2.13v-1A.82.82,0,0,0,8.7,61",
    style: {
      fill: "#516983",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#aff9449a-6cde-46fe-87a5-48f701b8e269)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -836.79,
    y: -604.22,
    width: 1528,
    height: 4751,
    style: {
      fill: "#516983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.17,61a.82.82,0,0,0-.82.82v1a.48.48,0,0,1-.48.48H11.3a.83.83,0,0,0,0,1.65h2.57A2.14,2.14,0,0,0,16,62.81v-1a.82.82,0,0,0-.83-.82",
    style: {
      fill: "#516983",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b0c89aee-de45-4f0b-96b8-86d0647e9d8d)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -836.79,
    y: -604.22,
    width: 1528,
    height: 4751,
    style: {
      fill: "#516983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.29,1V2.37c0,.77-.29,1-1.09,1s-1.07-.26-1.08-1c0-.39,0-.77,0-1.19H4.88c0,.42,0,.83,0,1.25,0,.72-.3,1-1.08,1s-1.07-.26-1.08-1c0-.45,0-.9,0-1.35C1.22.77.56,1,0,2.06V19A1.72,1.72,0,0,0,1.79,20Q10,20,18.21,20A1.72,1.72,0,0,0,20,19V2.06C19.49.75,18.39,1,17.29,1ZM19.1,6.49V18.24a2.46,2.46,0,0,1,0,.43s0,0,0,.08a.33.33,0,0,1-.05.12c-.11.16-.31.19-.71.19H1.36a.44.44,0,0,1-.44-.4,2,2,0,0,1,0-.26V5.48c0-.07,0-.14,0-.24H19.1Zm-14.71-5c0,.27,0,.54,0,.81a.63.63,0,0,1-1,.6.59.59,0,0,1-.19-.42c0-.66,0-1.31,0-2,0-.44.25-.48.58-.48s.64,0,.62.5C4.38.82,4.39,1.14,4.39,1.46Zm12.41,0v.81a.63.63,0,0,1-1,.6.6.6,0,0,1-.2-.42c0-.66,0-1.31,0-2,0-.49.3-.47.63-.48s.59.07.57.5S16.8,1.14,16.8,1.46Zm-13,9.15h1.1c.32,0,.45.15.45.46v2.08c0,.34-.14.5-.48.5H2.75c-.32,0-.46-.14-.45-.46,0-.71,0-1.43,0-2.14,0-.29.13-.43.42-.43Zm4.12,3c-1.51,0-1.51,0-1.51-1.52v-1c0-.33.11-.5.47-.49H9c.32,0,.46.13.46.45q0,1.06,0,2.13a.4.4,0,0,1-.46.46Zm8.3-3h1.1c.3,0,.43.14.44.43,0,.73,0,1.46,0,2.19,0,.29-.16.42-.44.42h-2.2a.37.37,0,0,1-.43-.43V11c0-.3.16-.42.44-.41Zm-4.14,3H11c-.29,0-.43-.13-.42-.43V11c0-.3.13-.42.42-.42h2.2c.29,0,.43.13.43.42q0,1.1,0,2.19a.37.37,0,0,1-.43.42ZM3.81,9.41H2.76c-.3,0-.47-.1-.46-.44q0-1.07,0-2.13c0-.34.16-.45.46-.44H4.9c.35,0,.48.16.48.5,0,.67,0,1.35,0,2,0,.37-.17.51-.52.49S4.16,9.41,3.81,9.41ZM8,9.41H6.88c-.32,0-.46-.15-.45-.46V6.87c0-.31.11-.48.43-.47h2.2c.31,0,.45.13.44.46,0,.69,0,1.38,0,2.08,0,.35-.15.48-.48.47Zm8.28,0c-1.55,0-1.55,0-1.55-1.56,0-.34,0-.68,0-1s.13-.43.42-.43h2.24c.3,0,.42.16.42.44,0,.71,0,1.42,0,2.13,0,.29-.13.44-.43.44ZM3.74,17.85c-.35,0-.7,0-1.05,0s-.48-.16-.47-.5c0-.67,0-1.35,0-2,0-.33.12-.49.47-.49H4.83c.35,0,.48.15.47.49,0,.68,0,1.36,0,2,0,.35-.12.51-.47.5S4.1,17.85,3.74,17.85Zm8.35-8.44H11c-.31,0-.47-.1-.47-.44q0-1.07,0-2.13c0-.34.16-.45.47-.45h2.15c.31,0,.44.14.44.46,0,.69,0,1.39,0,2.08,0,.36-.16.48-.49.47S12.44,9.41,12.09,9.41Zm-4.2,8.44c-.35,0-.7,0-1,0s-.47-.11-.47-.44c0-.71,0-1.43,0-2.14,0-.29.12-.44.41-.44H9c.32,0,.45.15.44.47,0,.69,0,1.39,0,2.08,0,.36-.16.48-.48.47S8.24,17.85,7.89,17.85Z",
    style: {
      fill: "#516983"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
export default __webpack_public_path__ + "static/media/datepicker.6c0eee83e5789cf25e0346aca61e9fbf.svg";
export { ForwardRef as ReactComponent };